import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { FormIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

export const Summary = () => {
  const { values: { inviteeQuestions, nameFormat } } = useFormContext()
  const numberOfActiveInviteeQuestions = inviteeQuestions.filter(({ enabled }) => enabled).length

  const summary = numberOfActiveInviteeQuestions > 0
    ? I18n.t(
      `publisher.event_type_editor.sections.booking_page_options.invitee_questions.summary.${nameFormat}.has_some`,
      { count: numberOfActiveInviteeQuestions }
    ) : I18n.t(
      `publisher.event_type_editor.sections.booking_page_options.invitee_questions.summary.${nameFormat}.has_none`
    )

  return (
    <BodyText color={colorTextSecondary} size="medium">
      <FormIcon size="standard" color={colorIconSecondary} spacingRight="8" />
      {summary}
    </BodyText>
  )
}
